import { FC } from "react";
import { OakLink, OakBox, OakSpan } from "@oaknational/oak-components";

import CopyrightLicence from "../CopyrightLicence/CopyrightLicence";

import { resolveOakHref } from "@/common-lib/urls";
import { FontProps } from "@/styles/utils/typography";

type OglCopyrightNoticeProps = FontProps & {
  showPostAlbCopyright: boolean;
  openLinksExternally: boolean;
  copyrightYear: string;
  fullWidth?: boolean;
};

const PreAlbCopyright = ({
  openLinksExternally,
  ...restProps
}: FontProps & { openLinksExternally: boolean }) => (
  <OakSpan $font="body-3" {...restProps}>
    This content is made available by Oak National Academy Limited and its
    partners and licensed under Oak’s{" "}
    {openLinksExternally ? (
      <OakLink
        href={resolveOakHref({
          page: "legal",
          legalSlug: "terms-and-conditions",
        })}
        target="_blank"
        aria-label="Terms and conditions (opens in a new tab)"
        iconName="external"
        isTrailingIcon
        data-testid="external-link-icon"
      >
        terms &amp; conditions
      </OakLink>
    ) : (
      <OakLink
        href={resolveOakHref({
          page: "legal",
          legalSlug: "terms-and-conditions",
        })}
        target={"_self"}
        aria-label="Terms and conditions"
      >
        terms &amp; conditions
      </OakLink>
    )}{" "}
    (Collection 1), except where otherwise stated.
  </OakSpan>
);

const OglCopyrightNotice: FC<OglCopyrightNoticeProps> = ({
  showPostAlbCopyright,
  openLinksExternally,
  copyrightYear,
  fullWidth,
  ...fontProps
}) => (
  <OakBox $maxWidth={fullWidth ? null : [null, "spacing-480", "spacing-480"]}>
    {showPostAlbCopyright ? (
      <CopyrightLicence
        {...fontProps}
        copyrightYear={copyrightYear}
        openLinksExternally={openLinksExternally}
      />
    ) : (
      <PreAlbCopyright
        {...fontProps}
        openLinksExternally={openLinksExternally}
      />
    )}
  </OakBox>
);

export default OglCopyrightNotice;
